import { AdministrateResourceDeleteButton } from "../../../components/AdministrateResourceDeleteButton";
import { useTableContext } from "../../../components/AdministrateTable";
import { useDestroyPermission, useUpdatePermission } from "../../../utils";
import { EditCustomerSuccessAutoAssignmentModal } from "./EditCustomerSuccessAutoAssignmentModal";

export const CustomerSuccessAutoAssignmentActionCell = ({ row }) => {
  const { refresh, setMessage, setError } = useTableContext();

  const [canDestroy] = useDestroyPermission("CustomerSuccessAutoAssignment", row.original.id);
  const [canUpdate] = useUpdatePermission("CustomerSuccessAutoAssignment", row.original.id);

  return (
    <>
      {canUpdate && (
        <EditCustomerSuccessAutoAssignmentModal
          color="link"
          customerSuccessAutoAssignment={row.original}
          onUpdate={(row) => {
            refresh();
            setMessage(`Updated Customer Success Auto Assignment ${row.id}.`);
          }}
        />
      )}

      {canDestroy && (
        <AdministrateResourceDeleteButton
          deleteUrl={`/admin/customer_success_auto_assignments/${row.original.id}`}
          onSuccess={() => {
            refresh();
            setMessage(`Deleted Customer Success Auto Assignment ${row.original.id}.`);
          }}
          onError={setError}
        />
      )}
    </>
  );
};
